import React, {ReactNode} from "react";

import {RequiredUserPermissionsSome} from "../../atoms/admin-user-permissions/RequiredUserPermissionsSome";
import {ReportingGroup} from "../../atoms/admin-reporting/atoms/reporting-group/ReportingGroup";
import {getSectionItemsPermissions} from "./permissions.helpers";
import {Section} from "./constants";
import {Context} from "./ReportContext";

export type ReportingSectionContext = Pick<
  Context,
  "baseDateRange" | "activeFacilitiesIds"
>;

export type ReportingSectionRenderer = (
  ctx: ReportingSectionContext,
) => ReactNode;

export const ReportingSectionFrame = ({
  section,
  children,
}: {
  section: Section;
  children: ReactNode;
}) => (
  <RequiredUserPermissionsSome
    permissions={getSectionItemsPermissions(section.sectionItems)}
  >
    <ReportingGroup
      id={section.id}
      title={section.title}
      sectionItems={section.sectionItems}
    >
      {children}
    </ReportingGroup>
  </RequiredUserPermissionsSome>
);
